import script from "./strategy-setting.vue?vue&type=script&setup=true&lang=ts"
export * from "./strategy-setting.vue?vue&type=script&setup=true&lang=ts"

import "./strategy-setting.vue?vue&type=style&index=0&id=11c3aa02&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11c3aa02"]])

export default __exports__